module.exports = __webpack_public_path__ + "img/1_034.0dd0eb46.jpg";